export default __webpack_public_path__ + "static/rsa_daily_lotto-93eba1352855632aaba5b933ab137f8d.png";